// services
import WsBasicService from '../Basic';
// consts
import { URL } from './const';
import { Messages } from './types';

class PortfolioFeedV2Store extends WsBasicService<Messages> {}

const WsPortfolioV2Feeder = new PortfolioFeedV2Store({ key: 'portfolioV2', URL });
export default WsPortfolioV2Feeder;
